import { render } from "./PartCarousel2.vue?vue&type=template&id=2f1bd8ad&ts=true"
import script from "./PartCarousel2.vue?vue&type=script&lang=ts"
export * from "./PartCarousel2.vue?vue&type=script&lang=ts"

import "./PartCarousel2.vue?vue&type=style&index=0&id=2f1bd8ad&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__